import * as styles from "/tools/js/svg/templates/svg.module.scss";
const SvgEntityPinpoint = ({ title, titleId, ...props }) => {
  props = Object.assign({}, props, {
    "aria-hidden": true,
  });
  if (!props.noAlign) {
    const className = (props.className || "") + " " + styles.alignIcon;
    props = Object.assign({}, props, {
      className,
    });
  }
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#src__com__yext__listingslaunchstorm__public__icons__entity-pinpoint_svg__a)">
        <path
          d="M12 4a6 6 0 0 0-6 6c0 2.222.75 2.917 4.727 9.294a1.5 1.5 0 0 0 2.546 0C17.253 12.915 18 12.223 18 10a6 6 0 0 0-6-6Zm0 14.5c-3.982-6.385-4.5-6.788-4.5-8.5a4.5 4.5 0 0 1 9 0c0 1.705-.474 2.044-4.5 8.5ZM9.5 10a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z"
          fill="#374151"
        />
      </g>
      <defs>
        <clipPath id="src__com__yext__listingslaunchstorm__public__icons__entity-pinpoint_svg__a">
          <path fill="#fff" transform="translate(6 4)" d="M0 0h12v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgEntityPinpoint;
